export default "__VITE_ASSET__BbrB7Nsn__"